import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {AdjusterDto} from "../../../../../auto-generated-server-dtos/adjuster/claim/assign-to/adjuster-dto";
import {environment} from "../../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class AssignToService {

  constructor(private httpClient: HttpClient) {
  }

  assignTo(claimId: number, adjusterUserId: string) {
    return this.httpClient.put(`${environment.apiServer}/Adjuster/Claim/AssignTo`, {
        claimId: claimId,
        userId: adjusterUserId
    });
  }

}
